import React from "react";
import loadable from "@loadable/component";
import CalendarIcon from "../../Icons/CalendarIcon";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import usePatchHook from "../../customHooks/usePatchHook";
import APIS from "../../constant/Endpoint";

const FiscalYearComponenent = loadable(
  () => import("../../components/FiscalYear/FiscalYear"),
);
const FiscalYear = () => {
  const { mutateAsync: patchUser } = usePatchHook({
    queryKey: ["fiscal-years"],
    navigateURL: null,
  });
  const handleIsActive = async (value: boolean, id: any) => {
    const payload = {
      is_active: value,
    };
    const url = `${APIS.FISCAL_YEAR}${id}/`;
    const formData = payload;
    try {
      await patchUser({ url, formData });
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CalendarIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Fiscal Year
        </span>
      </div>
      <FiscalYearComponenent handleIsActive={handleIsActive} />
    </>
  );
};

export default FiscalYear;
